export default function ScopeSection() {
  return (
    <section className="w-full bg-white py-8 md:py-10 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <div className="bg-[#fefce8] rounded-xl p-6 border-l-4 border-l-[#ea580c]">
          <h3 className="font-bold text-lg text-[#064e3b] mb-2">Honest Scope</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            Non-impact glass in existing frames only. Not impact-rated glass, hurricane glazing, full window units, or structural repairs. For impact and HVHZ jobs, we refer to licensed Florida contractors at no cost.
          </p>
        </div>
      </div>
    </section>
  );
}